import React from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { all_routes } from "../../../../Router/all_routes";

export default function PortalModal({ isOpen, onClose, onSelect, onSignOut }) {
  const navigate = useNavigate();
  const route = all_routes;

  if (!isOpen) return null;

  // Reset POS state
  localStorage.removeItem("pos_location");
  localStorage.removeItem("selectedMenuId");

  const options = [
    {
      key: "POS",
      label: "POS",
      color: "#39B9F0",
      icon: (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="42"
          height="42"
          viewBox="0 0 24 24"
          fill="none"
          stroke="#39B9F0"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <circle cx="9" cy="21" r="1"></circle>
          <circle cx="20" cy="21" r="1"></circle>
          <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
        </svg>
      ),
      action: () => {
        onSelect("POS");
        onClose();
        navigate(route.pos);
      },
    },
    {
      key: "BOOKINGS",
      label: "Back of House",
      color: "#28a745",
      icon: (
        <svg
  xmlns="http://www.w3.org/2000/svg"
  width="42"
  height="42"
  viewBox="0 0 24 24"
  fill="none"
  stroke="#28a745"
  strokeWidth="2"
  strokeLinecap="round"
  strokeLinejoin="round"
>
  <circle cx="12" cy="12" r="3"></circle>
  <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09c0-.69-.39-1.31-1-1.51a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06c.46-.46.63-1.14.33-1.82a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09c.69 0 1.31-.39 1.51-1 .31-.69.13-1.36-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06c.46.46 1.14.63 1.82.33.69-.31 1.14-.99 1.14-1.68V3a2 2 0 1 1 4 0v.09c0 .69.39 1.31 1 1.51.69.31 1.36.13 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06c-.46.46-.63 1.14-.33 1.82.31.69.99 1.14 1.68 1.14H21a2 2 0 0 1 0 4h-.09c-.69 0-1.31.39-1.51 1z"></path>
</svg>

      ),
      action: () => {
        onSelect("Booking");
        onClose();
        navigate(route.backOfHouse);
      },
    },
  ];

  return (
    <div
      className="modal d-block"
      style={{
        backgroundColor: "rgba(0,0,0,0.6)",
        zIndex: 1055,
      }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div
          className="modal-content border-0 shadow-lg rounded-4 p-4"
          style={{ width: "600px", maxWidth: "95%" }}
        >
          {/* HEADER */}
          <div className="modal-header border-0 pb-2">
            <h5 className="modal-title text-center w-100 fw-semibold">
              Select Mode
            </h5>
            <button type="button" className="btn-close" onClick={onClose}></button>
          </div>

          {/* BODY */}
          <div className="modal-body text-center">
            <div className="d-flex justify-content-center gap-4 mt-3">

              {options.map((item) => (
                <div
                  key={item.key}
                  onClick={item.action}
                  className="category-card shadow-sm p-3 text-center"
                  style={{
                    width: "180px",
                    cursor: "pointer",
                    transition: "0.2s",
                  }}
                >
                  <div
                    className="img-fluid mb-2"
                    style={{ fontSize: "40px", color: item.color }}
                  >
                    {item.icon}
                  </div>

                  <h6 className="mb-1">{item.label}</h6>
                  <div style={{ height: "20px" }}></div>
                </div>
              ))}

            </div>

            {/* SIGN OUT BUTTON */}
            <button
              className="btn btn-danger mt-4 w-100 py-2 rounded-3"
              onClick={() => {
                onSignOut();
                onClose();
              }}
            >
              Sign Out
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

PortalModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
  onSignOut: PropTypes.func.isRequired,
};
